/* Buddy: dealer finder (sections/buddy-dealers.liquid). Instant search, fylke chips, nearest-first, list/map toggle. */
(function () {
  'use strict';
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/æ/g, 'ae').replace(/ø/g, 'o')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/aa/g, 'a').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function km(a1, o1, a2, o2) {
    var R = 6371, r = Math.PI / 180, dA = (a2 - a1) * r, dO = (o2 - o1) * r;
    var h = Math.sin(dA / 2) * Math.sin(dA / 2) + Math.cos(a1 * r) * Math.cos(a2 * r) * Math.sin(dO / 2) * Math.sin(dO / 2);
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function fmtKm(d) { return (d < 10 ? d.toFixed(1).replace('.', ',') : String(Math.round(d))) + ' km'; }

  function init(root) {
    if (root.__bdl) return; root.__bdl = true;
    var finder = root.querySelector('[data-bdl-finder]');
    var bar = root.querySelector('[data-bdl-bar]');
    var input = root.querySelector('[data-bdl-q]');
    var clearBtn = root.querySelector('[data-bdl-clear]');
    var geoBtn = root.querySelector('[data-bdl-geo]');
    var status = root.querySelector('[data-bdl-status]');
    var empty = root.querySelector('[data-bdl-empty]');
    var resetBtn = root.querySelector('[data-bdl-reset]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-bdl-chips] [data-region]'));
    var heads = Array.prototype.slice.call(root.querySelectorAll('[data-bdl-group]'));
    var view = root.querySelector('[data-bdl-view]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-bdl-card]')).map(function (el) {
      return { el: el, region: el.getAttribute('data-region'), hay: norm(el.getAttribute('data-search')),
        lat: parseFloat(el.getAttribute('data-lat')), lng: parseFloat(el.getAttribute('data-lng')),
        dist: el.querySelector('[data-bdl-dist]'), d: null };
    });
    if (!bar || !input) return;
    var total = cards.length, region = 'all', geo = false;
    var tpl = root.getAttribute('data-status') || '{n} / {total}';

    function apply() {
      var tokens = norm(input.value).split(' ').filter(Boolean);
      var perRegion = {}, shown = 0, matchAll = 0;
      cards.forEach(function (c) {
        var q = tokens.every(function (t) { return c.hay.indexOf(t) !== -1; });
        if (q) { perRegion[c.region] = (perRegion[c.region] || 0) + 1; matchAll++; }
        var vis = q && (region === 'all' || c.region === region);
        c.el.hidden = !vis;
        if (vis) shown++;
      });
      heads.forEach(function (h) {
        var r = h.getAttribute('data-bdl-group');
        h.hidden = !(region === 'all' || region === r) || !perRegion[r];
      });
      chips.forEach(function (b) {
        var r = b.getAttribute('data-region'), n = r === 'all' ? matchAll : (perRegion[r] || 0);
        var nEl = b.querySelector('[data-n]'); if (nEl) nEl.textContent = n;
        b.setAttribute('aria-pressed', r === region ? 'true' : 'false');
        if (n === 0 && r !== region) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      });
      if (empty) empty.hidden = shown !== 0;
      if (clearBtn) clearBtn.hidden = input.value === '';
      var txt = tpl.replace('{n}', shown).replace('{total}', total);
      if (geo && root.getAttribute('data-status-geo')) txt += ' · ' + root.getAttribute('data-status-geo');
      if (status) status.textContent = txt;
    }
    function setGeo(on, pos) {
      geo = on;
      if (finder) finder.classList.toggle('is-geo', on);
      if (geoBtn) geoBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) {
        cards.forEach(function (c) { c.d = isFinite(c.lat) && isFinite(c.lng) ? km(pos.latitude, pos.longitude, c.lat, c.lng) : Infinity; });
        cards.slice().sort(function (a, b) { return a.d - b.d; }).forEach(function (c, i) {
          c.el.style.order = i + 1;
          if (c.dist && isFinite(c.d)) { c.dist.textContent = fmtKm(c.d); c.dist.hidden = false; }
        });
      } else {
        cards.forEach(function (c) { c.el.style.order = ''; if (c.dist) { c.dist.hidden = true; c.dist.textContent = ''; } });
      }
      apply();
    }
    function reset() {
      input.value = ''; region = 'all';
      if (geo) setGeo(false); else apply();
    }

    input.addEventListener('input', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; apply(); } if (e.key === 'Enter') { e.preventDefault(); input.blur(); } });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; apply(); input.focus(); });
    if (resetBtn) resetBtn.addEventListener('click', reset);
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        region = b.getAttribute('data-region');
        apply();
        var top = finder.getBoundingClientRect().top;
        if (top < 0) {
          var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
          window.scrollTo({ top: window.pageYOffset + bar.parentNode.querySelector('[data-bdl-panel="list"]').getBoundingClientRect().top - off - bar.offsetHeight - 8, behavior: 'smooth' });
        }
      });
    });

    var hasCoords = cards.some(function (c) { return isFinite(c.lat) && isFinite(c.lng); });
    if (geoBtn && hasCoords && 'geolocation' in navigator) {
      geoBtn.hidden = false;
      geoBtn.setAttribute('aria-pressed', 'false');
      geoBtn.addEventListener('click', function () {
        if (geo) { setGeo(false); return; }
        if (geoBtn) geoBtn.classList.add('is-loading');
        navigator.geolocation.getCurrentPosition(function (p) {
          if (geoBtn) geoBtn.classList.remove('is-loading');
          region = 'all';
          setGeo(true, p.coords);
        }, function () {
          if (geoBtn) geoBtn.classList.remove('is-loading');
          if (status) status.textContent = root.getAttribute('data-geo-error') || '';
        }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
      });
    }

    if (view) {
      var panels = { list: root.querySelector('[data-bdl-panel="list"]'), map: root.querySelector('[data-bdl-panel="map"]') };
      view.hidden = false;
      Array.prototype.forEach.call(view.querySelectorAll('[data-view]'), function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-view');
          Array.prototype.forEach.call(view.querySelectorAll('[data-view]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          panels.list.hidden = v !== 'list';
          if (panels.map) panels.map.hidden = v !== 'map';
          bar.hidden = v !== 'list';
          status.hidden = v !== 'list';
        });
      });
    }

    var params = new URLSearchParams(window.location.search);
    var pre = params.get('sted');
    if (pre) input.value = pre;
    bar.hidden = false;
    apply();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-bdl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-bdl]'); if (r) init(r); });
})();
